/*
#############################################################################
# Copyright (c) 2022-2023 NVIDIA CORPORATION & AFFILIATES. All rights reserved.
#
# NVIDIA CORPORATION, its affiliates and licensors retain all intellectual
# property and proprietary rights in and to this material, related
# documentation and any modifications thereto. Any use, reproduction,
# disclosure or distribution of this material and related documentation
# without an express license agreement from NVIDIA CORPORATION or
# its affiliates is strictly prohibited.
###############################################################################
*/

/* eslint-disable react/prop-types */
/* eslint-disable no-param-reassign */
/* eslint-disable no-use-before-define */
/* eslint-disable no-console */
/* eslint-disable jsx-a11y/media-has-caption */
import React from "react";
import MicIcon from "@mui/icons-material/Mic";
import MicOffIcon from "@mui/icons-material/MicOff";
import Grid from "@mui/material/Grid";
import Box from "@mui/material/Box";
import VolumeUpOutlinedIcon from "@mui/icons-material/VolumeUpOutlined";
import ErrorOutlineIcon from "@mui/icons-material/ErrorOutline";
import { useSelector } from "react-redux";
import Button from "@mui/material/Button";
import HourglassEmptyIcon from "@mui/icons-material/HourglassEmpty";
import { WEBRTC_STATUS } from "../../../config/config";
import WebrtcDataChannel from "../webrtc-data-channel/webrtcDataChannel";

function TopBarItems({micEnabled, handleMicrophoneUpdate}) {
  const ovState = useSelector((state) => state.ovState.ov);
  const webrtcStatus = useSelector(
    (state) => state.webrtcStatus.webrtcStatus
  );

  const webrtcNetworkQuality = useSelector(
    (state) => state.webrtcStatus.webrtcNetworkQuality
  );

  const handleVideoAudioRecording = () => {
    if (
      webrtcStatus === WEBRTC_STATUS.PENDING ||
      webrtcStatus === WEBRTC_STATUS.CONNECTED
    ) {
      handleMicrophoneUpdate(!micEnabled);
    }
  };

  const getMicIconColor = () => {
    if(webrtcStatus === WEBRTC_STATUS.CONNECTED) {
      if(webrtcNetworkQuality !== "low") {
        return "#76B900"; // green
      }
        return "#FEC119"; // yellow
    }
    return "#F03232"; // red
  }

  return (
    <Grid
      item
      sx={{
        display: "flex",
        flexDirection: "row",
        alignItems: "center",
        justifyContent: "space-between",
      }}
    >
      <Box
        sx={{
          display: "flex",
          flexDirection: "row",
          justifyContent: "center",
          align: "center",
        }}
      >
        <WebrtcDataChannel />
        <Button
          sx={{
            background: getMicIconColor(),
            marginRight: 1,
            "&:hover": {
              backgroundColor: getMicIconColor(),
            },
          }}
          onClick={handleVideoAudioRecording}
          variant='contained'
          disabled={webrtcStatus === WEBRTC_STATUS.PENDING}
        >
          {webrtcStatus === WEBRTC_STATUS.CONNECTED && micEnabled && <MicIcon />}
          {webrtcStatus === WEBRTC_STATUS.CONNECTED && !micEnabled && <MicOffIcon />}
          {webrtcStatus === WEBRTC_STATUS.PENDING && <HourglassEmptyIcon />}
          {webrtcStatus === WEBRTC_STATUS.ERROR && <ErrorOutlineIcon />}
          {webrtcStatus === WEBRTC_STATUS.UNINITIALIZED && <MicOffIcon />}
        </Button>
        <Button
          size='medium'
          variant='outlined'
          color='secondary'
          sx={{ width: 170, height: 33, color: "white" }}
          startIcon={<VolumeUpOutlinedIcon />}
        >
          {ovState}
        </Button>
      </Box>
    </Grid>
  );
}

export default TopBarItems;
